<template>
  <div>
    <SHeader :icon="ICON">
      <template v-slot:title>Capteurs</template>
      <template v-slot:action>
      </template>
    </SHeader>

    <SensorsTable @askUpdate="askUpdate" @onErrors="openAlert" />

    <SensorDialog
      :main-icon="ICON"
      v-if="dialog"
      :dialog="dialog"
      width="60%"
      :edited-sensor="sensor"
      @onUpdate="openUpdate"
      @closeDialog="closeDialog"
      @onErrors="openAlert"
    />

    <SAlert
      v-model="alert"
      :message="message"
      :success="successAlert"
      :error="!successAlert"
      :action-type="actionType"
      @onClose="alert = false"
    />
  </div>
</template>

<script>
import SensorsTable from "@/components/sensors/SensorsTable";
import SensorDialog from "@/components/sensors/SensorDialog";

export default {
  name: "Sensors",
  components: {
    SensorsTable,
    SensorDialog,
  },
  data: () => ({
    ICON: "fa-microchip",
    dialog: false,
    alert: false,
    successAlert: false,
    message: "",
    actionType: "normal",
    sensor: null,
  }),
  methods: {
    askUpdate(sensor) {
      this.dialog = true;
      this.sensor = sensor;
    },
    openUpdate() {
      this.openAlert({
        success: true,
        message: `Capteur ${this.sensor.macAddress} est modifié avec succès.`,
      });
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.sensor = null;
    },
    openAlert({ success, message }) {
      this.alert = true;
      this.successAlert = success;
      this.message = message;
    },
  },
};
</script>

<style></style>
